import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import { platformLabelMap } from 'services/config/platform';
import toLowerCase from 'utils/toLowerCase';
import { useStatusLabel } from 'views/Refund/components/StatusHistoryModal';

/** 退货单状态展示：根据平台与 displayStatus 推导出最终展示文案 */
export function useReturnStatusDisplay(
  platform: Conversation.Trade.TradeWithLogistics['platform'],
  displayStatus: Conversation.Trade.RefundReason['displayStatus'],
) {
  const { t } = useTranslate();
  const lazadaStatusLabel = useStatusLabel();

  const statusLabels = useMemo(
    () =>
      ({
        IN_REVIEW: t('状态展示枚举.IN_REVIEW'),
        WAITING_EVIDENCE: t('状态展示枚举.WAITING_EVIDENCE'),
        RETURN_PROCESSING: t('状态展示枚举.RETURN_PROCESSING'),
        PENDING_RESPOND: t('状态展示枚举.PENDING_RESPOND'),
        REFUND_APPROVED: t('状态展示枚举.REFUND_APPROVED'),
        WAITING_BUYER_RESPONSE: t('状态展示枚举.WAITING_BUYER_RESPONSE'),
        RETURN_IN_PROGRESS: t('状态展示枚举.RETURN_IN_PROGRESS'),
        REFUND_COMPLETED: t('状态展示枚举.REFUND_COMPLETED'),
        DISPUTE_RESOLVED: t('状态展示枚举.DISPUTE_RESOLVED'),
        CANCELLED: t('状态展示枚举.CANCELLED'),
        UNKNOWN: t('状态展示枚举.UNKNOWN', {
          platform: platformLabelMap[toLowerCase(platform)],
        }),
        RETURN_REFUND_PENDING: t('状态展示枚举.RETURN_REFUND_PENDING'),
        REFUND_REQUESTED: t('状态展示枚举.REFUND_REQUESTED'),
        VALIDATION_IN_PROGRESS: t('状态展示枚举.VALIDATION_IN_PROGRESS'),
        VALIDATION_IN_PROGRESS_V2: t('状态展示枚举.VALIDATION_IN_PROGRESS'),
        EVIDENCE_SUBMITTED: t('状态展示枚举.EVIDENCE_SUBMITTED'),
        COMPENSATION_APPROVED: t('状态展示枚举.COMPENSATION_APPROVED'),
        DISPUTE_REJECT: t('状态展示枚举.DISPUTE_REJECT'),
        DISPUTE_WAIT_EVIDENCE: t('状态展示枚举.DISPUTE_WAIT_EVIDENCE'),
        REFUND_APPROVED_2: t('状态展示枚举.REFUND_APPROVED'),
        ...lazadaStatusLabel,
      } as const),
    [t, lazadaStatusLabel, platform],
  );

  const displayStatusText = useMemo(() => {
    if (platform === 'mercado') {
      return t(`${toLowerCase(platform)}.returnStatus.${displayStatus}`);
    }
    return statusLabels[displayStatus as keyof typeof statusLabels] ?? displayStatus ?? '';
  }, [platform, displayStatus, t, statusLabels]);

  return {
    /** 有值时可展示，空字符串表示不展示 */
    displayStatusText: displayStatusText || null,
  };
}
